var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imagebox",style:(_vm.styleColor)},[(_vm.imgStyle.imageAdress)?_c('img',{class:_vm.transStyle.startRotate ? 'startImg' : '',style:(_vm.imgStyle),attrs:{"src":_vm.imgStyle.imageAdress,"alt":"","crossorigin":"anonymous"}}):_c('icon-font',{staticClass:"pic-icon",attrs:{"type":"icon-Picture02"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }